import { render } from "./Legend.vue?vue&type=template&id=443550c8&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"

import "./Legend.vue?vue&type=style&index=0&id=443550c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-443550c8"

export default script